// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*\n.menu {\n  position: absolute;\n  bottom: 0;  \n}\n*/\n._62A5lPZJDIiSwzzAy2RQy .btn {\n  margin-bottom: 10px;\n}\n/*\n@media (min-width: 768px) {\n  .menu {\n    position: relative;\n    bottom: auto;\n  }\n}\n*/\n\n.-jTtSU4c2P7lZhvb5_9HP h1 {\n  margin-top: 0;\n}\n\n._3Ek0tY4VkJykylYGPpdILr {\n  position: absolute;\n  right: -8px;\n  top: -8px;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n}", ""]);
// Exports
exports.locals = {
	"menu": "_62A5lPZJDIiSwzzAy2RQy",
	"headerFirstname": "-jTtSU4c2P7lZhvb5_9HP",
	"timereportsNotification": "_3Ek0tY4VkJykylYGPpdILr"
};
module.exports = exports;
